import React, { Fragment, useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { ChromePicker } from 'react-color';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import {
    Button,
    Row,
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
    InputGroup,
    Card,
    CardBody,
    CardImg,
    CustomInput,
    InputGroupAddon,
    InputGroupText,
    Input,
    Label,
} from 'reactstrap';
import ImageGallery from '../../../propinfo/gallery/index';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { API_FormSettings, gAPI_FormsBy_PropertyId } from '../../../../../../constants/APIs';
import {
    Colxx,
    Separator,
} from '../../../../../../components/common/CustomBootstrap';
import {
    setBackGroundColor,
} from "../../../integration/style/DigitalAssistantStyle";
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import myma_logo_greyscale from "../../../../../../assets/myma_greyscale.png";
import Validation from '../../../../../../components/Validation';
import DefaultNotification from './DefaultNotification';
function FormSettings({
    propertyId, LoadSetting, settings, locale
}) {
    const [loading, setLoading] = useState(true);
    const [edit, setEdit] = useState(true);
    const [formSettings, setFormSettings] = useState(settings !== null ? settings : {
        groupId: getGroupID(),
        propertyId: propertyId,
        privacyLink: "https://www.myma.ai/privacy-policy",
        footerLogo: myma_logo_greyscale,
        isHideFooterLogo: false,
        colors: {
            buttonColor: "#4a89dc",
            buttonTextColor: "#ffff"
        },
        defaultNotification: [],
        defaultForms: {
            isFeedbackForm: false,
            isLeaveMessageForm: false,
            feedbackFormId: '',
            leaveMessageFormId: ''
        },
        type: "Form"
    });
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const [error, setError] = useState(true);
    const [iseditMode, setEditMode] = useState({
        buttonColor: false,
        buttonTextColor: false,
    });
    const [galleryVisible, setGalleryVisible] = useState(false);
    const [isContact, setIsContact] = useState(false);
    const [formData, setFormsData] = useState([]);
    useEffect(() => {
        setFormSettings(settings);
        setLoading(false);
        AxiosAPI({
            method: 'get',
            url: `${gAPI_FormsBy_PropertyId}?groupId=${getGroupID()}&propertyId=${propertyId}&lang=${locale}`,
        })
            .then((res) => {
                setFormsData(res.data);
            })
            .catch((err) => console.error(err));
    }, [settings]);
    const SetClose = () => {
        setEditMode({
            buttonColor: false,
            buttonTextColor: false,
        });
    };
    const CloseColorBox = (event) => {
        if ((iseditMode.buttonColor === true ||
            iseditMode.buttonTextColor === true)) {
            SetClose();
        }
    };
    const togglegallery = () => {
        setGalleryVisible(!galleryVisible);
    };
    const selectedImage = (image) => {
        if (image !== undefined) {
            setFormSettings({ ...formSettings, footerLogo: image.src });
        }
    };
    const handleInputChange = (e) => {
        setFormSettings({ ...formSettings, privacyLink: e.target.value });
    }
    const handleCheckedFooterLogo = (e) => {
        setFormSettings({ ...formSettings, isHideFooterLogo: e.target.checked });
    }
    const handleFeedbackCheck = (value) => {
        var data = { ...formSettings.defaultForms };
        data.isFeedbackForm = value;
        setFormSettings({ ...formSettings, defaultForms: data });
    };
    const handleLeaveMsgCheck = (value) => {
        var data = { ...formSettings.defaultForms };
        data.isLeaveMessageForm = value;
        setFormSettings({ ...formSettings, defaultForms: data });
    };
    const handleFormChange = (value) => {
        var data = { ...formSettings.defaultForms };
        if (value.target.name === "feedbackFormId") {
            data.feedbackFormId = value.target.value;
        }
        else if (value.target.name === "leaveMessageFormId") {
            data.leaveMessageFormId = value.target.value;
        }
        setFormSettings({ ...formSettings, defaultForms: data });
    };
    const handleSave = (contact) => {
        if (contact !== undefined) {
            formSettings.defaultNotification = contact;
        }
        setLoading(true);
        AxiosAPI({
            method: 'post',
            url: `${API_FormSettings}/save`,
            data: formSettings,
        }).then((res) => {
            if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                && res.data.Messages !== null && res.data.Messages.length > 0) {
                setMsg(res.data.Messages);
                setOpen(true);
            }
            else {
                LoadSetting();
                setTimeout(() => {
                    setLoading(false);
                }, 500);
            }
        }).catch((err) => {
            console.log('err', err);
        });
    };
    const ImageGalleryButton = () => {
        return (
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal
                                isOpen={galleryVisible}
                                toggle={togglegallery}
                                style={{ maxWidth: '1000px' }}
                            >
                                <ModalHeader toggle={togglegallery}>Select Logo</ModalHeader>
                                <ModalBody>
                                    <ImageGallery
                                        selectedImage={selectedImage}
                                        togglegallery={togglegallery}
                                        hideUserUploads={false}
                                        searchText={''}
                                    />
                                </ModalBody>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        );
    };
    return (
        <Card>
            <CardBody name="bodyClick" onClick={(e) => { CloseColorBox(e); }}>
                {loading === false && formSettings && formSettings !== null ?
                    <Row className="mb-4">
                        <Colxx xxs="6">
                            <div >
                                <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                                    <div className='col-md-6 text-left' style={{
                                        marginTop: '0.30rem'
                                    }}><span className=''>Button Color</span></div>
                                    <div className='col-md-6'>
                                        <InputGroup>
                                            <Input
                                                className=""
                                                type="text"
                                                onChange={(e) => {
                                                    let colours = formSettings.colors;
                                                    colours.buttonColor = e.target.value;
                                                    setFormSettings({ ...formSettings, colors: colours });
                                                }}
                                                value={formSettings.colors.buttonColor}
                                            />
                                            <InputGroupAddon addonType="append">
                                                <InputGroupText onClick={() => {
                                                    setEditMode({ ...iseditMode, buttonColor: !iseditMode.buttonColor });
                                                }} className="color-square" style={setBackGroundColor(formSettings.colors.buttonColor)}></InputGroupText>
                                            </InputGroupAddon>
                                        </InputGroup>
                                    </div>
                                </div>
                            </div>
                            {iseditMode.buttonColor && <div className='parent-div'>
                                <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                                    <ChromePicker disableAlpha={true} className='ml-2'
                                        style={{ width: '240px' }}
                                        color={formSettings.colors.buttonColor}
                                        onChangeComplete={(e) => {
                                            if (edit) {
                                                let colours = formSettings.colors;
                                                colours.buttonColor = e.hex;
                                                setFormSettings({ ...formSettings, colors: colours });
                                                setEditMode({ ...iseditMode, buttonColor: false });
                                            } else setError(true);
                                        }}
                                    />
                                </div>
                            </div>}
                        </Colxx>
                        <Colxx xxs="6">
                            <div >
                                <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                                    <div className='col-md-6 text-left' style={{
                                        marginTop: '0.30rem'
                                    }}><span className=''>Button Text Color</span></div>
                                    <div className='col-md-6'>
                                        <InputGroup>
                                            <Input
                                                className=""
                                                type="text"
                                                onChange={(e) => {
                                                    let colours = formSettings.colors;
                                                    colours.buttonTextColor = e.target.value;
                                                    setFormSettings({ ...formSettings, colors: colours });
                                                }}
                                                value={formSettings.colors.buttonTextColor}
                                            />
                                            <InputGroupAddon addonType="append">
                                                <InputGroupText onClick={() => {
                                                    setEditMode({ ...iseditMode, buttonTextColor: !iseditMode.buttonTextColor });
                                                }
                                                } className="color-square" style={setBackGroundColor(formSettings.colors.buttonTextColor)}></InputGroupText>
                                            </InputGroupAddon>
                                        </InputGroup>
                                    </div>
                                </div>
                            </div>
                            {iseditMode.buttonTextColor && <div className='parent-div'>
                                <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                                    <ChromePicker disableAlpha={true} className='ml-2'
                                        style={{ width: '240px' }}
                                        color={formSettings.colors.buttonTextColor}
                                        onChangeComplete={(e) => {
                                            if (edit) {
                                                let colours = formSettings.colors;
                                                colours.buttonTextColor = e.hex;
                                                setFormSettings({ ...formSettings, colors: colours });
                                                setEditMode({ ...iseditMode, buttonTextColor: false });
                                            } else setError(true);
                                        }}
                                    />
                                </div>
                            </div>}
                        </Colxx>
                        <Colxx xxs="12" className="mb-2">
                            <b>Footer Logo</b><br />
                            <div className="thumbnail">
                                <img
                                    className="list-thumbnail responsive border-0"
                                    src={formSettings.footerLogo}
                                />
                            </div>
                            <div className="mb-1">
                                <Button
                                    color="success"
                                    size="xs"
                                    className="mt-1"
                                    onClick={togglegallery}
                                >
                                    Browse Logo
                                </Button>
                            </div>
                        </Colxx>
                        <Colxx xxs="12" className="mb-2">
                            <CustomInput
                                key="isHideFooterLogo"
                                type="checkbox"
                                checked={formSettings.isHideFooterLogo}
                                onChange={(e) => handleCheckedFooterLogo(e)}
                            ><span>Hide Footer Logo</span></CustomInput>
                        </Colxx>
                        <Colxx xxs="12" className="mb-2">
                            <b>Privacy Policy link</b>
                            <Input
                                type="textarea"
                                name="privacyLink"
                                value={formSettings.privacyLink}
                                onChange={(event) => handleInputChange(event)}
                            />
                        </Colxx>
                        <Colxx xxs="12" className="mb-2">
                            <Separator className="mb-5 mt-4" />
                            <h4 className='mb-1'>Choose Feedback Form</h4>
                            <p className='mb-3'>When customer clicks on thumbs down, a standard form is displayed to collect their feedback. Replace it with a custom form with this option</p>
                            <div className='d-flex'>
                                <Label>Use Custom Form</Label>
                                <Switch
                                    className="ml-2 agentswitch custom-switch-primary custom-switch-small"
                                    checked={formSettings.defaultForms.isFeedbackForm}
                                    onChange={(primary) => handleFeedbackCheck(primary)}
                                /></div>
                            <Input
                                className="w-50"
                                type="select"
                                name="feedbackFormId"
                                value={formSettings.defaultForms.feedbackFormId}
                                onChange={(e) => handleFormChange(e)}
                            >
                                <option value="">Select</option>
                                {formData && formData.map((item, i) =>
                                    <option value={item.id} key={i}>{item.name}</option>
                                )}
                            </Input>
                        </Colxx>
                        <Colxx xxs="12" className="mb-2">
                            <Separator className="mb-5  mt-4" />
                            <h4 className='mb-1'>Choose Leave A Message Form</h4>
                            <p className='mb-3'>When customer choose to leave a message,show this form</p>
                            <div className='d-flex'>
                                <Label>Use Custom Form</Label>
                                <Switch
                                    className="ml-2 agentswitch custom-switch-primary custom-switch-small"
                                    checked={formSettings.defaultForms.isLeaveMessageForm}
                                    onChange={(primary) => handleLeaveMsgCheck(primary)}
                                /></div>
                            <Input
                                className="w-50"
                                type="select"
                                name="leaveMessageFormId"
                                value={formSettings.defaultForms.leaveMessageFormId}
                                onChange={(e) => handleFormChange(e)}
                            >
                                <option value="">Select</option>
                                {formData && formData.map((item, i) =>
                                    <option value={item.id} key={i}>{item.name}</option>
                                )}
                            </Input>
                        </Colxx>
                        <Colxx xxs="12" className="mb-2">
                            <Separator className="mb-5 mt-4" />
                            <h4 className='mb-1'>Default Notification</h4>
                            <p className='mb-3'>Add a fallback email address, which will receive form submission notification in case there is no other email subscribed to the form.</p>
                            <Button
                                color="secondary"
                                size="xs"
                                outline
                                onClick={() => setIsContact(!isContact)}
                            >
                                + Add Notifications
                            </Button>
                        </Colxx>
                        <Colxx xxs="12" className='mb-2'>
                            <Button color="primary" size="xs" className="mt-5" outline onClick={() => handleSave()}>
                                Save
                            </Button>
                        </Colxx>
                    </Row> :
                    <div className="loading" />
                }
            </CardBody>
            <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
            {ImageGalleryButton()}
            {isContact &&
                <DefaultNotification
                    contacts={formSettings.defaultNotification}
                    visible={isContact}
                    toggle={() => setIsContact(false)}
                    saveContact={handleSave}
                ></DefaultNotification>}
        </Card >
    )
}
const mapStateToProps = ({ settings }) => {
    const { propertyId, locale } = settings;
    return {
        propertyId, locale
    };
};

export default injectIntl(connect(mapStateToProps, {})(FormSettings));